const allQuestions = [
  { id: 1, question: "What is the capital of India?", options: ["New Delhi", "Mumbai", "Kolkata", "Chennai"], correctAnswer: "New Delhi" },
  { id: 2, question: "Which goes faster?", options: ["Light", "Sound", "Wind", "Water"], correctAnswer: "Light" },
  { id: 3, question: "How many days are in a leap year?", options: ["364", "365", "366", "367"], correctAnswer: "366" },
  { id: 4, question: "Which animal is known as the Ship of the Desert?", options: ["Horse", "Camel", "Elephant", "Donkey"], correctAnswer: "Camel" },
  { id: 5, question: "What is 15 + 25?", options: ["30", "40", "45", "50"], correctAnswer: "40" },
  { id: 6, question: "How many colors are in a rainbow?", options: ["5", "6", "7", "8"], correctAnswer: "7" },
  { id: 7, question: "Which is the largest planet in our solar system?", options: ["Earth", "Mars", "Jupiter", "Saturn"], correctAnswer: "Jupiter" },
  { id: 8, question: "What do bees produce?", options: ["Milk", "Honey", "Wax", "Both Honey and Wax"], correctAnswer: "Both Honey and Wax" },
  { id: 9, question: "Which shape has 3 sides?", options: ["Square", "Circle", "Triangle", "Rectangle"], correctAnswer: "Triangle" },
  { id: 10, question: "What is the freezing point of water?", options: ["0°C", "10°C", "100°C", "-10°C"], correctAnswer: "0°C" },
  // ... more questions can be added here
];

export const getDailyQuestions = () => {
  const today = new Date();
  const start = new Date(today.getFullYear(), 0, 0);
  const diff = today - start;
  const oneDay = 1000 * 60 * 60 * 24;
  const dayOfYear = Math.floor(diff / oneDay);
  
  const totalSets = Math.floor(allQuestions.length / 10);
  const setIndex = dayOfYear % totalSets;
  const startIndex = setIndex * 10;
  
  return allQuestions.slice(startIndex, startIndex + 10);
};

export default allQuestions;
